import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import FileUploadComponent from "../components/FileUploadComponent/FileUpload.component";
import { getLast7days, getTodayDate } from "aw-date-functions";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import StepsToFollow from "../components/StepsToFollowComponent/StepsToFollow.component";
import DownloadsGrid from "../components/DownloadsGridComponents/DownloadsGrid/DownloadsGrid.component";
import { Instalation } from "../utils/models/Instalation";
import { Machine } from "../utils/models/Machine";
import { getInstalationsByCompany } from "../utils/services/instalation.service";
import { orderByLabel } from "aw-generic-functions";
import { getMachinesByInstallation } from "../utils/services/machine.service";
import SearchBar from "../components/ButtonsLineComponent/SearchBar.component";
import { useTheme } from "../utils/contexts/ThemeContext";
import { ISelectOptions } from "aw-combobox";

const KnowledgeModulePage = () => {
    const { t } = useTranslation();
    const context: IOutletContext = useOutletContext();
    const [loadingData, setLoadingData] = useState(true);
    const [fileSent, setFileSent] = useState(false)
    const [fileName, setFileName] = useState('')
    const [category, setCategory] = useState('')
    const [version, setVersion] = useState('')
    const [iniDate, setIniDate] = useState(getLast7days());
    const [finDate, setFinDate] = useState(getTodayDate());
    const [installations, setInstallations] = useState<Instalation[]>([])
    const [allInstalationsObj, setAllInstalationsObj] = useState<ISelectOptions[]>([])
    const [selectedInstallation, setSelectedInstallation] = useState<ISelectOptions>()
    const [machines, setMachines] = useState<Machine[]>([])
    const [allMachinesObj, setAllMachinesObj] = useState<ISelectOptions[]>([])
    const [selectedMachine, setSelectedMachine] = useState<ISelectOptions>()
    const user = useSelector(selectUser)

    const { idinstalation } = useParams();
    const { idmachine } = useParams();
    const theme = useTheme()

    useEffect(() => {
        context.setState(t('Knowledge'));
    }, [context, t]);

    useEffect(() => {
        getInstalationsByCompany(user.token, user.company.idcompany)
            .then((i: Instalation[]) => {
                if (i.length === 0) throw new Error('No Installations');

                setInstallations(i);

                const iObj = orderByLabel(i.map((i: Instalation) => ({
                    label: i.name,
                    value: i.idinstalation
                })));

                // Insertar la opción de "All Installations"
                const allOption = { label: t('AllInstallations'), value: -1 };
                const updatedInstallations = [allOption, ...iObj];
                setAllInstalationsObj(updatedInstallations);

                let selectedInstAux = allOption; // default

                if (idinstalation) {
                    const found = i.find((ins) => ins.idinstalation === parseInt(idinstalation));
                    if (found) selectedInstAux = { label: found.name, value: found.idinstalation };
                }
                setSelectedInstallation(selectedInstAux);
            })
            .catch((e) => {
                console.error('Error getInstalationsByCompany', e);
            })
            .finally(() => {
                setTimeout(() => setLoadingData(false), 250);
            });
    }, []);


    useEffect(() => {
        if (selectedInstallation && selectedInstallation.value !== -1) {
            getMachinesByInstallation(user.token, Number(selectedInstallation.value))
                .then((m: Machine[]) => {
                    if (m.length === 0) throw new Error('No Machines');

                    setMachines(m);

                    const mObj = orderByLabel(m.map((m: Machine) => ({
                        label: m.name,
                        value: m.idmachine
                    })));

                    const allOption = { label: t('AllMachinesSelect'), value: -1 };
                    const updatedMachines = [allOption, ...mObj];
                    setAllMachinesObj(updatedMachines);

                    let selectedMachAux = allOption;

                    if (idmachine) {
                        const found = m.find((mac) => mac.idmachine === Number(idmachine));
                        if (found) selectedMachAux = { label: found.name, value: found.idmachine };
                    }

                    setSelectedMachine(selectedMachAux);
                })
                .catch((e) => console.error("Error getMachinesByInstallation:", e))
                .finally(() => setTimeout(() => setLoadingData(false), 250));
        } else {
            // Si es selecciona All Installations
            const allOption = { label: t('AllMachinesSelect'), value: -1 };
            setAllMachinesObj([allOption]);
            setSelectedMachine(allOption);
        }
    }, [selectedInstallation]);


    const onChangeDates = () => {
        console.log("dates changed");
    }

    const reloadButtonClick = () => {
        setLoadingData(true)
        setTimeout(() => setLoadingData(false), 500)
        console.log("Machines List", machines)
        console.log("Machines Options", allMachinesObj)
    }

    const uploadFileButtonClick = () => {
        setLoadingData(true)
        setFileSent(true)
        setTimeout(() => {
            setLoadingData(false)
            setFileSent(false)
        }, 1000);
    }

    return (
        <>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    <SearchBar role={user.role} defaultIni={iniDate} company={(user.company.name)} disableMachineSelect={selectedInstallation?.value === -1}
                        defaultFin={finDate} onChangeDates={onChangeDates} onChangeSelect={(selectedInstallation) => { setSelectedInstallation(selectedInstallation) }}
                        onClickReload={reloadButtonClick} options={allInstalationsObj} selected={selectedInstallation || { label: "", value: 0 }} rounded='rounded-1'
                        classNameSuccess='btn-Custom btn-IDGreen' containerColor='var(--background-secondary)' dark={theme.theme === 'dark' ?  true : false} downloadButton={false} optionsFilter2={allMachinesObj}
                        selectedFilter2={selectedMachine || { label: "", value: 0 }} onChangeSelect2={(selectedMachine) => { setSelectedMachine(selectedMachine) }} />
                </div>
            </div>
            <div className="row border-0 ms-2 me-2 mt-1">
                <div className="col-12 col-md-6 col-lg-6 mb-2 px-1 mt-1">
                    <FileUploadComponent selectedInstallation={selectedInstallation} selectedMachine={selectedMachine} setVersion={setVersion} loading={loadingData} uploadFileClick={uploadFileButtonClick} setFileName={setFileName} setCategory={setCategory} />
                </div>
                <div className="col-12 col-md-6 col-lg-6 mb-2 px-1 mt-1">
                    <StepsToFollow />
                </div>
            </div>
            <div className="row border-0 ms-2 me-2 mb-1">
                <div className="col-12 mb-2 px-1 mt-1">
                    <DownloadsGrid loading={loadingData} installations={installations} machines={machines} sent={fileSent} date={finDate} fileName={fileName} category={category} version={version} selectedInstallation={selectedInstallation} selectedMachine={selectedMachine} />
                </div>
            </div>
        </>
    )
}

export default KnowledgeModulePage;
